import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#f6efde]">
      <Header />
      {/* 페이지 공통 컨텐츠 */}
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
